import { HomeOutlined } from "@ant-design/icons";
import { Link } from "@tanstack/react-router";
import { Breadcrumb } from "antd";
import type { ItemType } from "antd/es/breadcrumb/Breadcrumb";
import { useLayoutStore } from "layout/store";
import { useMemo } from "react";

export function Breadcrumbs() {
	const breadcrumbs = useLayoutStore((s) => s.breadcrumbs);

	const items = useMemo(() => {
		const innerItems: ItemType[] = [];

		const home = {
			title: (
				<Link to={"/a/painel-gerencial"}>
					<HomeOutlined style={{ paddingRight: 5 }} />
					Início
				</Link>
			),
		};

		innerItems.push(home);

		breadcrumbs?.forEach((title) => {
			innerItems.push({
				title,
			});
		});

		return innerItems;
	}, [breadcrumbs]);

	return (
		<div className="px-4 pt-3 md:px-8">
			<Breadcrumb items={items} separator=">" className="m-0 text-base md:text-[17px]" />
		</div>
	);
}
